module.exports = __webpack_public_path__ + "img/hero-bg.5c3504df.png";